export default {
  textContainer: {
    margin: '10px',
    fontSize: '14px'
  }
};
